import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { Sgkc006aRequest, TankatableLstInformationDto, SGKC006AService } from 'sg-api';

/**
* 単価表取得API使用サービス
* @export
* @class UsedSgkc006aService
*/
@Injectable({
    providedIn: 'root'
})
export class UsedSgkc006aService {

    /**単価表取得結果のSubject */
    private _tankatableResult$: Subject<Array<TankatableLstInformationDto>> = new Subject<Array<TankatableLstInformationDto>>();

    /**
   * コンストラクタ
   * @param {SGKC006AService} sGKC006AService
   * @param {ApiCommonService} apiCommonService
   * @param {TimeApiService} timeApiService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgkc006aService
   */
    constructor(
        private sGKC006AService: SGKC006AService,
        private apiCommonService: ApiCommonService,
        private timeApiService: TimeApiService,
        @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
    ) { }

    /**
     * 単価表取得結果のobservable提供
     * @readonly
     * @memberof UsedSgkc006aService
     */
    get tankatableChanges() {
        return this._tankatableResult$.asObservable();
    }

    /**
     * 単価表取得API呼び出し
     * @param {Sgkc006aRequest} value 
     * @return {Observable<Array<TankatableLstInformationDto>>} 
     * @memberof UsedSgkc006aService
     */
    searchTankatable(value: Sgkc006aRequest): Observable<Array<TankatableLstInformationDto>> {
        // 年月日項目のフォーマット
        this.apiCommonService.convertElementInObject(value, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
        // 検索条件を保存
        return this.sGKC006AService.kC10RSGKC006APost(<Sgkc006aRequest>this.apiCommonService.setRequestCommon(value), 'response')
            .pipe(
                map(response => {
                    // エラーが設定されていないかチェックする
                    this.apiCommonService.checkError(response);
                    this._tankatableResult$.next(response.body.tankatableLstInformationlist);
                    return response.body.tankatableLstInformationlist;
                }),
                timeout(Number(this.featuresLibConfig.httpTimeout)),
                catchError((err) => {
                    this.apiCommonService.dispErrorMessage(err, 'sgkc', 'SGKC006A');
                    return throwError(err.message);
                })
            );
    }
}
